import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { CloudTypes } from 'src/app/core/models/globals';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from '../../../../core/services/environment.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { UserRoleNames } from 'src/app/core/models/users';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-storage-details',
  templateUrl: './storage-details.component.html',
  styleUrls: ['./storage-details.component.scss']
})
export class StorageDetailsComponent implements OnInit {

  isOnPremise: boolean;
  storage: Storage;
  storageName: string;
  depName: string;
  fieldTextType1: boolean = true;
  fieldTextType2: boolean = true;
  storageDetailsSub: Subscription;
  vmIp: string | null;
  cloudType: string = this._Activatedroute.parent.parent.snapshot.params['cloudType'] || this._Activatedroute.parent.snapshot.params['cloudType'];
  showServiceConnectInfo = this.cloudType == CloudTypes.OnPremise;
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;

  constructor(
    private _Activatedroute: ActivatedRoute,
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
    private navService: NavigationService,
    private env: EnvironmentService,
    private snackBar: MatSnackBar, private utilityService: UtilityService,
    private _headerService: HeaderService ,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.navService.sendParentData('Properties');
    this.navService.sendLeftPanelIndex(1);
    this.spinner.show();
    this._Activatedroute.parent.params.subscribe((params) => {
      this.storageName = params['storageName'];
      this.depName = params['deploymentName'];
      if(!this.showServiceConnectInfo){
        this.showServiceConnectInfo = Boolean(this._headerService.getValueOfIsLocalStoreForDeployment(this.depName));
        if(this.showServiceConnectInfo) this.getHeadNodeIp();
      }
    });
    if(this.cloudType == CloudTypes.OnPremise){
      this.getHeadNodeIp();
    }
    this.storageDetailsSub = this.storageService
      .getStorage(this.storageName, this.depName)
      .subscribe({
        next: (data) => {
          this.storage = <Storage>JSON.parse(JSON.stringify(data));
          if (this.storage.cloud === CloudTypes.OnPremise) {
            this.isOnPremise = false;
          } else {
            this.isOnPremise = true;
          }
          this.spinner.hide();
        }, error: (err) => {}
      })
  }

  ngOnDestroy(){
    if(this.storageDetailsSub) this.storageDetailsSub.unsubscribe()
  }

  togglePassswordIcon1(){
    this.fieldTextType1 = !this.fieldTextType1;
  }
  
  togglePassswordIcon2(){
    this.fieldTextType2 = !this.fieldTextType2;
  }

  getHeadNodeIp(){
    this.storageService.getHeadNodeIp(this.depName).subscribe({
      next: (data: any)=> {
        this.vmIp = JSON.parse(JSON.stringify(data.vmIp));
      },
      error: (err) => {
      }
    })
	}

  redirectToVmIP(){
    if (!this.vmIp) {
      this.snackBar.open("This Feature is in Progress For VDI Deployment", "Ok", {
        duration: 5000
      })
      return;
    } 
    window.open(`${this.env.envVariables.httpProtocol}${this.vmIp}:${this.env.envVariables.UtilityAccessPort}/authorize`, "_blank");
  }
}
